import {combineReducers} from "redux";
import teamReducer from "./reducer";

const reducer = combineReducers({
    teamReducer,
})
  
export default reducer;